import {MatchTiming, Sponsor} from "../javaTypes";
import { createContext } from "react";
import {ParsedMatchTiming, parseMatchTiming} from "../utils";

export interface DivisionInfo {
    name: string,
    abbrev: string,
    logo?: string,
    sponsor?: Sponsor,
    inverseSponsor?: Sponsor,
}

interface BaseParams {
    eventCode: string,
    eventName: string,
    eventLocation: string,
    fieldCount: number,
    liveDisabled: boolean,
    liveUpdateUrl: string,
    inspectionStatusUpdateUrl: string,
    divisionNumber: number,
    isDualDivisionParent: boolean,
    isFirstChampionship: boolean,
    divisions: Record<number, DivisionInfo>,
    isLeagueMeet: boolean,
    missingLeague: boolean,
    showMeetRankings: boolean,
    sponsorsUrl: string,
    alternatePresentingSponsor: string,
    matchTiming: ParsedMatchTiming,
    keyScoreValues: Record<string, number>,
    eventLogo?: string,
    matchPrefixLogo?: string,
    interdivisionName?: string,
    interdivisionMatchPrefixLogo?: string,
    eventSponsor?: Sponsor,
    eventInverseSponsor?: Sponsor,
    avatarUrl?: string,
}

// The Partial allows referring to all fields without style conditionals
type RemoteAwardsParams = Partial<BaseParams> &  {
    style: 'remoteAwards'
} & Pick<BaseParams,
  "eventCode" |
  "eventName" |
  "eventLocation" |
  "liveUpdateUrl" |
  "sponsorsUrl"
>

type CloudPitParams = Partial<BaseParams> &  {
    style: 'cloudPit'
} & Pick<BaseParams,
  "eventCode" |
  "eventName" |
  "eventLocation" |
  "liveUpdateUrl" |
  "divisionNumber" |
  "isDualDivisionParent" |
  "isFirstChampionship" |
  "divisions" |
  "isLeagueMeet" |
  "missingLeague" |
  "showMeetRankings"
>

type StandardDisplay = BaseParams &  {
    style: 'default'
}

export type DisplayParamsType = RemoteAwardsParams | CloudPitParams | StandardDisplay

declare global {
    /* @ts-ignore spurious TS2717: Subsequent property declarations must have the same type */
    interface Window { displayParams: DisplayParamsType; }
}

const params = window.displayParams;
// matchTiming will be serialized as strings, but we want it as Durations
if(params?.matchTiming) {
    params.matchTiming = parseMatchTiming(params.matchTiming as unknown as MatchTiming);
}
const DisplayParams = createContext<DisplayParamsType>(params);
export default DisplayParams;